const StorageService = {

    addItem: (key, value, ttl = -1) => {

        const item = {
            value: value,
            expiry: ttl !== -1 ? new Date().getTime() + (ttl * 1000 * 60) : ttl,
        }

        localStorage.setItem(key, JSON.stringify(item))

    },
    getItem: (key) => {

        const jsonStringItem = localStorage.getItem(key)

        if (!jsonStringItem)
            return null;

        const item = JSON.parse(jsonStringItem);

        if (item.expiry !== -1 && new Date().getTime() > item.expiry) {
            localStorage.removeItem(key)
            return null
        }

        return item.value
    },
    removeItem: (key) => {
        localStorage.removeItem(key);
        return null;
    },
    removeExpiredItems: async () => {

        const keys = Object.keys(localStorage);

        const isJsonMessage = data => {
            try {
                JSON.parse(data);
            } catch (e) {
                return false;
            }
            return true;
        };

        for (let key of keys) {

            if(isJsonMessage(localStorage.getItem(key))) {
                const item = JSON.parse(localStorage.getItem(key));
                if (item.expiry !== -1 && new Date().getTime() > item.expiry) {
                    localStorage.removeItem(key)
                }
            }

        }

        return null;
    }

}

export default StorageService;